// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__1pkia","tab":"Tabs_tab__pAeQr","active":"Tabs_active__uMxxx"};